<template>
  <q-dialog v-model="isShow" full-height full-width persistent>
    <q-card style="width: 700px; max-width: 200vw;">
      <q-card-section>
        <div class="text-h6">搜尋增加產品</div>
      </q-card-section>

      <q-card-section>
        <div class="row q-gutter-xs">
          <div class="col col-12">
            <q-select 
              filled 
              v-model="search.category" 
              :options="originCategory" 
              option-value="OnlineId" 
              option-label="title" 
              emit-value 
              map-options 
              use-input
              label="產品分類" 
              @filter="selectFilter"
              @input="selectChange" 
            >
              <template v-slot:append>
                <q-icon
                  v-if="search.category !== null"
                  class="cursor-pointer"
                  name="clear"
                  @click.stop="search.category = '', selectChange()"
                />
              </template>
            </q-select>
          </div>
          <div class="col col-12">
            <q-select
              filled
              v-model="search.tag"
              :options="tagList"
              option-value="id"
              option-label="title"
              emit-value
              multiple
              map-options
              label="產品標籤"
              @input="selectChange"
            >
              <template v-slot:append>
                <q-icon
                  v-if="search.tag !== null"
                  class="cursor-pointer"
                  name="clear"
                  @click.stop="search.tag = [], selectChange()"
                />
              </template>
            </q-select>
          </div>
          <div class="col col-12">
            <q-table
              title=""
              :data="searchList"
              :columns="columns"
              row-key="title"
              :filter="filter"
              :pagination.sync="tableSet"
            >
              <template v-slot:top-right="props">
                <q-input borderless filled dense debounce="300" v-model="filter" placeholder="搜尋牙材">
                  <template v-slot:append>
                    <q-icon name="search" />
                  </template>
                </q-input><br>
              </template>
              <template v-slot:body="props">
                <q-tr :props="props">
                  <q-td key="category" :props="props">{{ props.row.category_title }}</q-td>
                  <q-td key="title" :props="props"><ProductTitle :product-data="props.row" /></q-td>
                  <q-td key="nickName" :props="props">{{ props.row.nick_name }}</q-td>
                  <q-td key="safeStock" :props="props">{{ props.row.safe_stock }}</q-td>
                  <q-td key="stock" :props="props">{{ props.row.stock }}</q-td>
                  <q-td key="action" :props="props">
                    <q-btn
                      color="blue"
                      icon="add"
                      label=""
                      @click="(joinEventHandle)? joinEventHandle(props.row) : handleJoinClick(props.row)"
                    />
                  </q-td>
                </q-tr>
              </template>
            </q-table>
          </div>
        </div>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn label="OK" color="primary" @click="handleCloseSearch" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ProductTitle from '@/components/ProductTitle'
  export default {
    name: "SuggestSearch",
    components: { ProductTitle },
    props: {
      isShow: {
        type: Boolean,
        default: false
      },
      isLocal: {
        type: Boolean,
        default: false
      },
      joinEventHandle: {
        type: Function,
        default: null
      },
      selectedProduct : {
        type: Array,
        default: () => [],
      },
      dataListAction: {
        type: String,
        default: "productGetListForAddSuggest"
      }
    },
    data() {
      return {
        showSearch: false,
        products: [],
        searchList: [],
        filter: '',
        selectCategoryList : [],
        originCategory: [],
        search: {
          category: '',
          tag: [],
          hasStock: 3,
        },
        columns: [
          // { name: 'img', label: '物料暱稱', field: 'nick_name' },
          { name: 'category', label: '分類', sortable: true },
          { name: 'title', align: 'center', label: '產品名稱', field: 'title', sortable: true },
          { name: 'safeStock', label: '安全庫存', field: 'safe_stock', sortable: true },
          { name: 'stock', label: '庫存', sortable: true },
          { name: 'action', label: '操作', align: 'center', field: 'id' }
        ],
        tableSet: {
            sortBy: 'desc',
            descending: false,
            page: 1,
            rowsPerPage: 10
        }, 
      }
    },
    computed: {
      selectedProductIDs () {
        return (this.selectedProduct && this.selectedProduct.length >0)? this.selectedProduct : this.products
      },
      ...mapGetters(['categoryList', 'suggestList', 'productList', 'tagList'])
    },
    created() {
      this.$store.dispatch('categoryGetList')
      .then(res =>{
        this.originCategory = res
        this.selectCategoryList = res
      })
      this.$store.dispatch('TagList');
      this.selectChange()
    },
    methods: {
      selectChange() {
        this.$store.dispatch(this.dataListAction, this.search)
        .then(res => {
          this.searchList = []
          res.map(r => {
            r.category_title = (r.Category )?r.Category.title : ''
            if(this.selectedProductIDs.indexOf(r.id) === -1) {
              this.searchList.push(r)    
            } 
          })
          
        })
      },
      handleJoinClick(product) {
        product.is_local = (this.isLocal)? "1" : "0"
        this.$store.dispatch('suggestAdd', product).then(res => {
            let color = 'blue'
            if (!res.Answer) {
              color = 'red'
            }
            this.$q.notify({
              position: 'top',
              color,
              message: res.Message
            })
            this.selectChange()
          })
        // 2022/10/19 取消加入確認
        // this.$q.dialog({
        //   dark: true,
        //   title: '確認！',
        //   message: `是否確定要加入${product.title}`,
        //   cancel: true,
        //   persistent: true
        // }).onOk(() => {

        // })
      },
      selectFilter(val, update) {
        if (val === '') {
          update(() => {
            this.originCategory = this.selectCategoryList
          })
          return
        }

        update(() => {
          const needle = val
          this.originCategory = this.selectCategoryList.filter(v => v.title.indexOf(needle) > -1)
        })
      },
      handleCloseSearch() {
        this.$emit('updateSearchShow')
      }
    }
  }
</script>

<style scoped>

</style>
